import {toast} from 'react-toastify'
export const AppToast = {toast}
